module.exports = __webpack_public_path__ + "static/media/img_02.b152f7c5.jpg";